<template>
<div>
  <div v-if="enabled" class="item"
  role="button"
  tabindex="0"
  style="cursor: auto;"
  draggable="false"
  @click="click"
  @dblclick="dblclick"
  :aria-label="name"
  :aria-selected="isSelected">
    <div class="backuprow">
      <div class="backupname column">
        <copy-icon size="1.2x" class="custom-class"></copy-icon>
        <p :title="name">{{ name }}</p>
      </div>
      <div v-if="!isSmallMobile()" class="backupdevice column">
        <monitor-icon size="1.2x" class="custom-class"></monitor-icon>
        <p :title="device">{{ device }}</p>
      </div>
      <div v-if="!isSmallMobile()" class="backupdate column">
        <calendar-icon size="1.2x" class="custom-class"></calendar-icon>
        <p>
          <time :datetime="modified">{{ humanTime() }}</time>
        </p>
      </div>
      <div v-if="isSmallMobile()" class="column info">
        <button @click="isShow = true" :aria-label="$t('buttons.moreInformation')" :title="$t('buttons.moreInformation')" class="action" id="info-button">
          <info-icon size="1.5x" class="custom-class"></info-icon>
        </button>
        <div class="information" :style="infoStyle">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <h3>{{ $t('settings.copyInformation') }}</h3>
            <x-icon @click="isShow = false" size="1.5x" class="custom-class"></x-icon>
          </div>
          <div class="backupname column">
            <copy-icon size="1.2x" class="custom-class"></copy-icon>
            <p :title="name">{{ name }}</p>
          </div>
          <div class="backupdevice column">
            <monitor-icon size="1.2x" class="custom-class"></monitor-icon>
            <p :title="device">{{ device }}</p>
          </div>
          <div class="backupdate column">
            <calendar-icon size="1.2x" class="custom-class"></calendar-icon>
            <p>
              <time :datetime="modified">{{ humanTime() }}</time>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import filesize from 'filesize';
import moment from 'moment';
import { CopyIcon, MonitorIcon, CalendarIcon, XIcon, InfoIcon } from 'vue-feather-icons';

export default {
  name: 'item',
  data: function () {
    return {
      timer: 0,
      isShow: false
    };
  },
  components: {
    CopyIcon,
    MonitorIcon,
    CalendarIcon,
    InfoIcon,
    XIcon
  },
  props: ['date', 'device', 'progress', 'name', 'enabled', 'url', 'type', 'size', 'modified', 'index', 'handle'],
  computed: {
    ...mapState(['selected', 'req']),
    ...mapGetters(['selectedCount']),
    isSelected () {
      return (this.selected.indexOf(this.index) !== -1);
    },
    infoStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    ...mapMutations(['addSelected', 'removeSelected', 'resetSelected']),
    isSmallMobile: function () {
      return window.innerWidth <= 450;
    },
    humanSize: function () {
      return filesize(this.size);
    },
    humanTime: function () {
      return moment(this.date).format('DD/MM/YYYY HH:mm');
      //return moment(this.date).fromNow()
    },
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    isIos: function() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    click: function () {
      /*if (!this.isMobile()) {
        this.select(event);
        return;
      }

      if (this.selectedCount !== 0) {
        if (this.$store.state.selected.indexOf(this.index) !== -1) {
          this.removeSelected(this.index)
          return
        }

        this.addSelected(this.index)
        return;
      }
      this.open();*/
    },
    dblclick: function () {
      if (!this.isMobile()) {
        this.open();
      }
    },
    select: function (event) {
      if (this.selectedCount !== 0) event.preventDefault();
      if (this.$store.state.selected.indexOf(this.index) !== -1) {
        this.removeSelected(this.index);
        return;
      }

      if (event.shiftKey && this.selected.length === 1) {
        let fi = 0;
        let la = 0;

        if (this.index > this.selected[0]) {
          fi = this.selected[0] + 1;
          la = this.index;
        } else {
          fi = this.index;
          la = this.selected[0] - 1;
        }

        for (; fi <= la; fi++) {
          this.addSelected(fi);
        }

        return;
      }

      //if (!event.ctrlKey && !this.$store.state.multiple) this.resetSelected()
      if (!event.ctrlKey) this.resetSelected();
      this.addSelected(this.index);
    },
    open: function () { 
      this.$router.push({path: this.url});
    }
  }
};
</script>
